import { getAccessToken, getRefressToken } from "@/api"
import { isTokenExpired, AppBridge } from '@/assets/js/common.js'
import { store } from '@/store/index'

export default class TokenServices {
  constructor () {
    this.accessToken = null
    this.refreshToken = null
    this.effective = null
  }

  // 액세스토큰 갱신 사이클
  async _watchToken () {
    console.log('TokenService - _watchToken')
    let result = false
    let accessTokenExpired = false
    let refreshTokenExpired = false

    // 비로그인 상태면 옵저버 종료
    if (!sessionStorage.getItem('accessToken') && !sessionStorage.getItem('refreshToken')) {
      this.accessToken = null
      this.refreshToken = null
      return false
    }

    // 가지고 있는 정보와 session 정보가 다르면 정보갱신
    if (this.accessToken !== sessionStorage.getItem('accessToken') || this.refreshToken !== sessionStorage.getItem('refreshToken')) {
      return this._setToken()
    }


    accessTokenExpired = isTokenExpired(sessionStorage.getItem('accessToken'), 'accessToken')
    refreshTokenExpired = isTokenExpired(sessionStorage.getItem('refreshToken'), 'refreshToken')

    if (refreshTokenExpired === 14) { result = await this._refreshToken('refreshToken') }
    if (refreshTokenExpired === 30) { 
      alert('오랫동안 활동이 없어, 재로그인이 필요합니다.')
      store.dispatch('logOut')
      return true
    }
    if (accessTokenExpired) { result = await this._refreshToken('accessToken') }

    return result
  }

  // 토큰 설정
  _setToken () {
    console.log('TokenService - _setToken')
    if (sessionStorage.getItem('accessToken')) { this.accessToken = sessionStorage.getItem('accessToken') }
    if (sessionStorage.getItem('refreshToken')) { this.refreshToken = sessionStorage.getItem('refreshToken') }

    return this._watchToken()
  }


  // 토큰 갱신 함수
  async _refreshToken (flag) {
    let UA = navigator.userAgent.toLowerCase()
    let res = null

    if (flag !== 'refreshToken') {
      res = await getAccessToken(this.refreshToken)
    } else {
      res = await getRefressToken(this.refreshToken)
    }
    console.log('TokenService - refreshToken : ', res)
    if (res.data.jsonData.resultCode === '0001') {
      this.accessToken = res.data.jsonData.accessToken
      sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)

      if (res.data.jsonData.refreshToken) {
        this.refreshToken = res.data.jsonData.refreshToken
        sessionStorage.setItem('refreshToken', res.data.jsonData.refreshToken)

        if (UA.includes('native') && UA.includes('ios')) {
          AppBridge.set(
            'saveUser',
            JSON.stringify({ refreshToken: res.data.jsonData.refreshToken })
          )
        } else {
          localStorage.setItem(
            'saveUser',
            JSON.stringify({ refreshToken: res.data.jsonData.refreshToken })
          )
        }
      }

      return false
    } else {
      alert('토큰 갱신에 실패했습니다. 새로고침 해 주세요.')
      return true
    }
  }
}